'use client'
/* Full-color platform brand marks for the large showcase stage.
   The small chip strip stays monochrome (RegistryIcon) — see ChannelsHero.
   International marks are authored inline in official brand colors; Iranian
   marks use the original color assets in public/platforms/. */

const IG_GLYPH =
  'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z'
const TG_CIRCLE =
  'M11.94 0A12 12 0 0 0 0 12 12 12 0 0 0 12 24 12 12 0 0 0 24 12 12 12 0 0 0 12 0 12 12 0 0 0 11.94 0Z'
const TG_PLANE =
  'M16.91 7.22C17.01 7.22 17.23 7.25 17.37 7.36A0.51 0.51 0 0 1 17.54 7.69C17.56 7.78 17.58 8 17.56 8.16 17.38 10.06 16.6 14.66 16.2 16.79 16.03 17.69 15.7 17.99 15.38 18.02 14.69 18.08 14.16 17.56 13.48 17.12 12.43 16.42 11.83 15.99 10.8 15.32 9.62 14.54 10.39 14.11 11.06 13.41 11.24 13.22 14.31 10.43 14.37 10.18 14.38 10.14 14.38 10.03 14.31 9.96S14.14 9.92 14.06 9.94C13.96 9.96 12.27 11.08 9 13.29 8.52 13.62 8.09 13.78 7.7 13.77 7.27 13.76 6.45 13.52 5.84 13.33 5.08 13.08 4.49 12.95 4.54 12.54 4.57 12.32 4.86 12.1 5.43 11.87 8.93 10.35 11.26 9.34 12.43 8.86 15.76 7.47 16.45 7.23 16.91 7.22Z'
const WA_GLYPH =
  'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884z'
const YT_BODY =
  'M23.5 6.19A3.02 3.02 0 0 0 21.38 4.05C19.5 3.54 12 3.54 12 3.54S4.5 3.54 2.62 4.05A3.02 3.02 0 0 0 0.5 6.19C0 8.07 0 12 0 12S0 15.93 0.5 17.81A3.02 3.02 0 0 0 2.62 19.95C4.49 20.45 12 20.45 12 20.45S19.5 20.45 21.38 19.95A3.02 3.02 0 0 0 23.5 17.81C24 15.93 24 12 24 12S24 8.07 23.5 6.19Z'
const YT_TRI = 'M9.54 15.57V8.43L15.82 12 9.54 15.57Z'
const X_GLYPH =
  'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z'
const BALE_BUBBLE =
  'M13.7 0.1C13.7 0.1 13.6 0.1 13.6 0.1 13.5 0.1 13.3 0.1 13.1 0.1 13 0 13 0 12.9 0 12.8 0 12.6 0 12.5 0 12.4 0 12.3 0 12.2 0 12.2 0 12.1 0 12 0 12 0 11.9 0 11.9 0 11.9 0 11.8 0 11.8 0 11.8 0 11.7 0 11.7 0 11.6 0 11.5 0 11.4 0 11.3 0 11.3 0 11.2 0 11.1 0 11 0 10.9 0 10.9 0.1 10.8 0.1 10.7 0.1 10.6 0.1 10.6 0.1 10.5 0.1 10.4 0.1 10.3 0.1 10.2 0.1 10.2 0.1 10.1 0.2 10 0.2 9.9 0.2 9.8 0.2 9.8 0.2 9.7 0.2 9.6 0.2 9.5 0.3 9.5 0.3 9.4 0.3 9.3 0.3 9.2 0.3 9.2 0.3 9.1 0.4 9 0.4 8.9 0.4 8.9 0.4 8.8 0.4 8.7 0.5 8.6 0.5 8.6 0.5 8.5 0.5 8.4 0.5 8.3 0.6 8.3 0.6 8.2 0.6 8.1 0.6 8 0.7 8 0.7 7.9 0.7 7.8 0.7 7.8 0.8 7.7 0.8 7.6 0.8 7.5 0.9 7.5 0.9 7.4 0.9 7.3 0.9 7.3 1 7.2 1 7.1 1 7.1 1.1 7 1.1 6.9 1.1 6.9 1.2 6.8 1.2 6.7 1.2 6.6 1.3 6.6 1.3 6.5 1.3 6.4 1.4 6.4 1.4 6.3 1.4 6.2 1.5 6.2 1.5 6.1 1.5 6 1.6 6 1.6 5.9 1.7 5.8 1.7 5.8 1.7 5.7 1.8 5.6 1.8 5.6 1.9 5.5 1.9 5.4 2 5 2.3 5 2.3 5 2.3 2.8 0.6 1.9 0.2 1-0.3 0 0.3 0 1.3V3.5 11.8C0 11.8 0 11.9 0 12 0 18.4 5 23.6 11.2 24 11.2 24 11.3 24 11.3 24 11.4 24 11.6 24 11.7 24 11.8 24 11.8 24 11.9 24 11.9 24 11.9 24 12 24 12 24 12 24 12 24 12.1 24 12.2 24 12.3 24 12.4 24 12.5 24 12.6 24 12.7 24 12.8 24 12.9 24 13 24 13.1 24 13.2 23.9 13.3 23.9 13.4 23.9 13.5 23.9 13.6 23.9 13.7 23.9 13.8 23.9 13.9 23.9 14 23.8 14.1 23.8 14.2 23.8 14.3 23.8 14.4 23.8 14.5 23.7 14.6 23.7 14.7 23.7 14.8 23.7 14.9 23.7 15 23.6 15.1 23.6 15.2 23.6 15.3 23.5 15.3 23.5 15.4 23.5 15.5 23.5 15.6 23.4 15.7 23.4 15.8 23.4 15.9 23.3 16 23.3 16.1 23.3 16.2 23.2 16.3 23.2 16.4 23.2 16.5 23.1 16.6 23.1 16.6 23.1 16.7 23 16.8 23 16.9 22.9 17 22.9 17.1 22.9 17.2 22.8 17.3 22.8 17.4 22.7 17.4 22.7 17.5 22.7 17.6 22.6 17.7 22.6 17.8 22.5 17.9 22.5 18 22.4 18 22.4 18.1 22.3 18.2 22.3 18.3 22.2 18.4 22.2 18.4 22.1 18.5 22.1 18.6 22 18.7 22 18.8 21.9 18.8 21.9 18.9 21.8 19 21.7 19.1 21.7 19.2 21.6 19.2 21.6 19.3 21.5 19.4 21.5 19.5 21.4 19.5 21.3 19.6 21.3 19.7 21.2 19.8 21.1 19.8 21.1 19.9 21 20 21 20.1 20.9 20.1 20.8 20.2 20.8 20.3 20.7 20.3 20.6 20.4 20.6 20.5 20.5 20.5 20.4 20.6 20.4 20.7 20.3 20.7 20.2 20.8 20.2 20.9 20.1 20.9 20 21 19.9 21.1 19.9 21.1 19.8 21.2 19.7 21.2 19.6 21.3 19.6 21.4 19.5 21.4 19.4 21.5 19.3 21.5 19.3 21.6 19.2 21.7 19.1 21.7 19 21.8 19 21.8 18.9 21.9 18.8 21.9 18.7 22 18.6 22 18.6 22.1 18.5 22.2 18.4 22.2 18.3 22.3 18.2 22.3 18.2 22.4 18.1 22.4 18 22.5 17.9 22.5 17.8 22.5 17.7 22.6 17.6 22.6 17.6 22.7 17.5 22.7 17.4 22.8 17.3 22.8 17.2 22.9 17.1 22.9 17 22.9 16.9 23 16.8 23 16.8 23.1 16.7 23.1 16.6 23.1 16.5 23.2 16.4 23.2 16.3 23.2 16.2 23.3 16.1 23.3 16 23.3 15.9 23.4 15.8 23.4 15.7 23.4 15.7 23.5 15.6 23.5 15.5 23.5 15.4 23.5 15.3 23.6 15.2 23.6 15.1 23.6 15 23.6 14.9 23.7 14.8 23.7 14.7 23.7 14.6 23.7 14.5 23.8 14.4 23.8 14.3 23.8 14.2 23.8 14.1 23.8 14 23.8 13.9 23.9 13.8 23.9 13.7 23.9 13.6 23.9 13.5 23.9 13.4 23.9 13.3 23.9 13.2 24 13.1 24 13 24 12.8 24 12.8 24 12.7 24 12.6 24 12.4 24 12.2 24 12 24 12 24 12 24 12 24 5.9 19.5 0.9 13.7 0.1Z'
const BALE_CHECK =
  'M19 10.5L12 17.4C11.6 17.9 11 18.1 10.4 18.1 9.8 18.1 9.2 17.9 8.7 17.4L5 13.7C4.1 12.8 4.1 11.3 5 10.4 5.9 9.5 7.4 9.5 8.3 10.4L10.4 12.5 15.7 7.2C16.6 6.2 18.1 6.2 19 7.2 19.9 8.1 19.9 9.6 19 10.5Z'

type MarkProps = { className?: string }

/* eslint-disable @next/next/no-img-element -- original color SVG assets; no optimizer win */
function ImgMark({ src, alt, className }: { src: string; alt: string; className?: string }) {
  return (
    <img src={src} alt={alt} className={className} style={{ objectFit: 'contain' }} aria-hidden />
  )
}
/* eslint-enable @next/next/no-img-element */

function InstagramMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <defs>
        <radialGradient id="ig-mark" cx="30%" cy="107%" r="150%">
          <stop offset="0%" stopColor="#fdf497" />
          <stop offset="5%" stopColor="#fdf497" />
          <stop offset="45%" stopColor="#fd5949" />
          <stop offset="60%" stopColor="#d6249f" />
          <stop offset="90%" stopColor="#285AEB" />
        </radialGradient>
      </defs>
      <rect width="24" height="24" rx="5.4" fill="url(#ig-mark)" />
      <path d={IG_GLYPH} fill="#fff" transform="translate(3.6 3.6) scale(0.7)" />
    </svg>
  )
}

function TelegramMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="tg-mark" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#2AABEE" />
          <stop offset="100%" stopColor="#229ED9" />
        </linearGradient>
      </defs>
      <path d={TG_CIRCLE} fill="url(#tg-mark)" />
      <path d={TG_PLANE} fill="#fff" />
    </svg>
  )
}

function WhatsAppMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <circle cx="12" cy="12" r="12" fill="#25D366" />
      <path d={WA_GLYPH} fill="#fff" fillRule="evenodd" transform="translate(2.4 2.4) scale(0.8)" />
    </svg>
  )
}

function YouTubeMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path d={YT_TRI} fill="#fff" />
      {/* full path (body + triangle) with evenodd: triangle becomes a hole
          revealing the white layer beneath */}
      <path d={`${YT_BODY} ${YT_TRI}`} fill="#FF0000" fillRule="evenodd" />
    </svg>
  )
}

function LinkedInMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <rect width="24" height="24" rx="2.7" fill="#0A66C2" />
      <rect x="3.55" y="9" width="3.57" height="11.45" fill="#fff" />
      <circle cx="5.34" cy="5.37" r="2.06" fill="#fff" />
      <path
        d="M9.35 9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.29h-3.56v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35z"
        fill="#fff"
      />
    </svg>
  )
}

function XMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path d={X_GLYPH} fill="#fff" />
    </svg>
  )
}

function BaleMark({ className }: MarkProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
      <path d={BALE_CHECK} fill="#fff" />
      {/* bubble + check with evenodd: check becomes a hole over the white layer */}
      <path d={`${BALE_BUBBLE} ${BALE_CHECK}`} fill="#31B545" fillRule="evenodd" />
    </svg>
  )
}

/** Full-color mark registry, keyed by the marquee/platform id. */
export const brandMarks: Record<string, (p: MarkProps) => React.ReactNode> = {
  instagram: InstagramMark,
  telegram: TelegramMark,
  whatsapp: WhatsAppMark,
  youtube: YouTubeMark,
  linkedin: LinkedInMark,
  twitter: XMark,
  bale: BaleMark,
  rubika: (p) => <ImgMark src="/platforms/rubika.svg" alt="Rubika" {...p} />,
  soroush: (p) => <ImgMark src="/platforms/soroush-color.svg" alt="Soroush+" {...p} />,
  eitaa: (p) => <ImgMark src="/platforms/eita.svg" alt="Eitaa" {...p} />,
}

export function BrandMark({ id, className }: { id: string; className?: string }) {
  const Mark = brandMarks[id]
  return Mark ? <Mark className={className} /> : null
}
